import React, { useEffect, useRef } from 'react';
import './SoftwareProjects.css';
import ProjectCard from './ProjectCard';

import sedna from '../assets/sedna.png';
import trust from '../assets/trust.webp';

import flipped from '../assets/flipped.webp';

const projects = [
  {
    title: 'Sedna',
    paragraph: 'Reducing costs by 80% for Maritime Communication and Operations',
    image: sedna,
    backgroundColor: '#f5f0fe',
  },
  {
    title: 'TrustPortal',
    paragraph: 'TrustPortal transforms the customer experience while reducing operations costs by 40-50%',
    image: trust,
    backgroundColor: '#f2fae9',
  },
  {
    title: 'Flipped Normals',
    paragraph: 'Full Marketplace Migration In Just 2 Months Led To Scalable Infrastructure and Improved Traffic',
    image: flipped,
    backgroundColor: '#ffeff8',
  },
];

const ProjectsSection = () => {
  const centerCardRef = useRef(null);
  const previousScrollY = useRef(window.scrollY);
  const yOffset = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      if (centerCardRef.current) {
        const change = direction === 'down' ? -1.5 : 1.5;
        let newOffset = yOffset.current + change;
        newOffset = Math.max(-40, Math.min(40, newOffset));
        yOffset.current = newOffset;

        centerCardRef.current.style.transform = `translate3d(0, ${newOffset}px, 0)`;
      }

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <div className="projects-header123">
          <div className="projects-header-left">
            <h2>
              PROJECTS<br />
             <span className='blue-text123'>SUCCESFULLY DELIVERED</span>
            </h2>
          </div>
          <div className="projects-header-right">
            <p>
              Since 2020, we’ve delivered more than 300 web and software products, in over 15 different industries.
            </p>
          </div>
        </div>

        <div className="project-card-group">
          {projects.map((item, i) => (
            <div
              key={i}
              ref={i === 1 ? centerCardRef : null}
              className="project-card-wrapper"
            >
              <ProjectCard
                title={item.title}
                paragraph={item.paragraph}
                image={item.image}
                backgroundColor={item.backgroundColor}
                isCentered={i === 1}
              />
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
};

export default ProjectsSection;
